module.exports = __webpack_public_path__ + "img/four03.696912ec.png";